import { defineStore  } from 'pinia'
import httpService from '@/utils/httpService'
import { URL } from '@/constants/urls'

export const useAllTableStore = defineStore('all-table', {
  state: () => ({
    tables: []
  }),

  getters : {
    category : (state) => {
      const floors = state.tables.map(e => e.floor)
      const types = state.tables.map(e => e.type)
      return ['全部'].concat(Array.from(new Set(floors))).concat(Array.from(new Set(types)))
    },
  },
  
  actions: {
    async getAllTables(){
      const res = await httpService.post(URL.TABLE_ALL_TABLE_RETRIEVE, {})
      this.tables = res
    },
  },
});